import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ROPPage from "../pages/rop/page";
import Client360Page from "../pages/client360/page";
import ManagerWorkspacePage from "../pages/managerWorkspace/page";
import OperatorWorkspacePage from "../pages/operatorWorkspace/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rop",
    element: <ROPPage />,
  },
  {
    path: "/client360",
    element: <Client360Page />,
  },
  {
    path: "/manager-workspace",
    element: <ManagerWorkspacePage />,
  },
  {
    path: "/operator-workspace",
    element: <OperatorWorkspacePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;